export const getStatusCandasColumns = (t, data, langOption) => {
	const { birthPlaceKz, birthPlaceRu, statusAssignmentDate, ticketValidity, districtKz, districtRu } = data || {}
	return [
		{ title: t('qandas.place_of_birth'), data: langOption === 'rus' ? birthPlaceRu : birthPlaceKz },
		{ title: t('qandas.assignment_date'), data: statusAssignmentDate },
		{ title: t('qandas.expiration_date'), data: ticketValidity },
		{ title: t('qandas.name_of_mio'), data: langOption === 'rus' ? districtRu : districtKz },
	].map((item) => (!!item.data ? item : { ...item, data: '-' }))
}
